<template>
	<div class="subscribe-list">
		<nav-bar :navBarTitle="titleText" v-if="titleText"></nav-bar>
		<div v-for="(obj,index) in listData" :key="index" class="subscribe-list-wrap">
			<div class="title">
				<span class="title-l">{{ obj.keyword }}</span>
				<span class="title-r"  @click="goMorePage(obj)">历史政策></span>
			</div>
			<ul v-if="obj.list.length">
				<li v-for="(item,index1) in obj.list" :key="index1" class="policylist" @click="goDetailPage(item)">
					<list-item :item-data="item"></list-item>
				</li>
			</ul>
			<div v-else class="img-wrap"  @click="goDetailPage(item)">
				<!--<img src="../../assets/img/no-data.png" width="96"/>-->
				<span class="img-desc">暂无未读政策</span>
			</div>
		</div>
	</div>
</template>

<script>
	import ListItem from '../../components/ListItem'
	import { cardShareInfo, reqUnReadPlicy } from '../../api';
	import { getUrlParams } from '../../utils';

	export default {
		name: 'subscribelist',
		components:{
			ListItem
		},
		data(){
			return {
				id:null,
				listData:[],
				city:'',
				titleText:''
			}
		},
		beforeCreate () {
			document.title = getUrlParams('city') || ''
		},
		created(){
			this.id = getUrlParams('id') || 0
			this.getList()
			this.titleText =getUrlParams('city') || ''
		},
		mounted(){
			this.defaultShare()
		},
		methods:{
			// 默认分享
			async defaultShare(){
				let params = {
					type: 9, // 普通分享到产品首页
					title: '政策补贴宝',
					desc: '每个企业都有获得补贴的机会，我们让可能变为现实',
				}
				let res = await cardShareInfo(params)
				if(res && res.ok){
					let data = res.data
					this.WechatShare({
						title: data.title,
						desc: data.desc,
						imgUrl: data.imgUrl,
						link: data.linkUrl
					},window.initUrl ? window.initUrl: '')
				}
			},
			async getList(){
				let res = await reqUnReadPlicy({id: this.id})
				if(res.ok){
					this.listData = JSON.parse(JSON.stringify(res.data))
					this.listData.forEach((obj)=>{
						obj.list.length && obj.list.map((element)=>{
							this.$set(element,'isRead', false)
						})
					})
				}
			},
			goMorePage(obj){
				let data = JSON.parse(JSON.stringify(obj))
				console.log('keyWord',data)
				this.$router.push({
					path:'/member/subscribedetail',
					query:{
						id: this.id,
						keyWord: data.keyword
					},
				})
			},
			goDetailPage(obj) {
				let item = JSON.parse(JSON.stringify(obj))
				console.log('详情',item)
				// eslint-disable-next-line
				sensors.track('policyClick', {
					policy_id: item.policyId,
					policy_name: item.policyName,
					policy_show_type: "非模糊",
					match_level: item.matchScore,
					policy_department: item.department,
					max_declare: item.maxSubsidy
				})
				this.$router.push({
					path: '/detail',
					query: {
						policyId: item.policyId,
						isRead: item.isRead,
					}
				})
			},
		}
	};
</script>

<style scoped lang="less">
	.subscribe-list{
		.subscribe-list-wrap{
			padding: 12px 13px 20px 15px;
		}
		.title{
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 16px 0;
			.title-l{
				font-size: 20px;
				line-height: 20px;
				font-weight: 500;
				color: #000000;
			}
			.title-r{
				font-size: 14px;
				font-weight: 400;
				color: #398DFF;
				line-height: 14px;
				padding: 5px;
			}
		}
		.img-wrap{
			width: 100%;
			box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
			height: 35px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}
		.img-desc{
			/*height: 14px;*/
			font-size: 14px;
			font-weight: 400;
			color: #666666;
			line-height: 14px;
		}
	}

</style>
